<script setup>
import { NuxtLink } from '#components'
import { slugifyString } from '~/utils/slugify'

const props = defineProps({
  teaser: {
    type: Object,
    required: true,
  },
  small: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <component
    :is="props.teaser?.button?.to ? NuxtLink : 'div'"
    :to="props.teaser?.button?.to"
    class="teaser d-flex"
  >
    <div class="teaser__image">
      <NuxtImg
        v-if="props.teaser?.image?.src"
        sizes="sm:340px md:440px lg:800px"
        densities="1x 2x"
        :src="props.teaser?.image?.src"
        :alt="props.teaser?.image?.alt"
        class="img-fluid"
        loading="lazy"
        format="webp"
        :placeholder="[300, 200, 60, 2]"
      />
    </div>
    <div class="d-flex flex-column teaser__content">
      <h3
        :id="slugifyString(props.teaser?.title)"
        class="teaser__title"
        :class="{
          'scale-3 scale-3--bold-uppercase': !props.small,
          'scale-1 scale-1--bold-uppercase': props.small,
        }"
      >
        {{ props.teaser?.title }}
      </h3>
      <FormButton
        v-if="props.teaser?.button?.label"
        class="l-button--outlined teaser__button l-button--secondary"
        :label="props.teaser?.button?.label"
        :to="props.teaser?.button?.to"
        :rel="props.teaser?.button?.rel"
      />
    </div>
  </component>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.teaser {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;

  &__image {
    position: relative;
    display: flex;
    width: 100%;
    height: auto;

    img {
      position: relative;
      display: flex;
      object-fit: cover;
      min-width: 100%;
      min-height: 100%;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.1) 30%,
        rgba(0, 0, 0, 0.5) 70%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }
  }

  &__content {
    position: absolute;
    text-align: left;
    bottom: 0;
    left: 0;
    padding: 38px;
    height: 100%;
    width: 100%;

    @include media-breakpoint-down(640) {
      padding: 25px 20px;
    }
  }

  &__title {
    margin-top: auto;
    text-transform: uppercase;
  }

  &__button {
    margin-top: 15px;
  }
}
</style>
